module.exports = __webpack_public_path__ + "img/warning.cdf36cf0.png";